import React from "react";
// import './styles.css';
import {isMobile,isBrowser} from "react-device-detect";
import { makeStyles } from "@material-ui/core/styles";
import { Paper, Grid, Box, Typography } from "@material-ui/core";
import StarHero from '../giving-tuesday/components/star-hero';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock } from "@fortawesome/free-solid-svg-icons";

// import useStyles from './styles'

const donateBannerDesktop =
  /*"https://res.cloudinary.com/loanpal/image/upload/w_1440,q_93,dpr_auto,c_scale/v1637804536/givepower/donate/donate-main-banner-3x.jpg";
  "https://res.cloudinary.com/loanpal/image/upload/w_1440,q_93,dpr_auto,c_scale/v1650576779/givepower/donate/donate-main-banner-apr22-3x.jpg";"
  "https://res.cloudinary.com/loanpal/image/upload/w_1440,q_93,dpr_auto,c_scale/v1699664708/givepower/donate/DESKTOP_donate.givepower.org_Header-v2.jpg"*/
  "https://res.cloudinary.com/loanpal/image/upload/w_1440,q_93,dpr_auto,c_scale/v1708030257/givepower/donate/DESKTOP_donategivepowerorg_Header.png"

  const donateBannerMobile =
  /*"https://res.cloudinary.com/loanpal/image/upload/w_auto,q_93,dpr_auto,c_scale/v1637804536/givepower/donate/donate-main-banner-mobile-3x.jpg";
  "https://res.cloudinary.com/loanpal/image/upload/w_auto,q_93,dpr_auto,c_scale/v1650576776/givepower/donate/donate-main-banner-apr22-mobile-3x.jpg"; 
  "https://res.cloudinary.com/loanpal/image/upload/w_auto,q_93,dpr_auto,c_scale/v1699664707/givepower/donate/MOBILE_donate.givepower.org_Header-v1.jpg"*/
  "https://res.cloudinary.com/loanpal/image/upload/w_auto,q_93,dpr_auto,c_scale/v1708030256/givepower/donate/MOBILE_donategivepowerorg_Header.png"

  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing(1),
      textAlign: "center",
      [theme.breakpoints.down("sm")]: {
        padding: 0,
      },
      [theme.breakpoints.up("sm")]: {
        padding: 0,
      },
      [theme.breakpoints.up("md")]: {
        padding: theme.spacing(1),
      },
    },
    img: {
      margin: "auto",
      display: "block",
      maxWidth: "100%",
      maxHeight: "100%",
      [theme.breakpoints.down("sm")]: {
        marginBottom: "-30px",
      },
    },
    paperCenter: {
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      height: "100%",
    },
    padding3: {
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
    },
    questions: {
      fontSize: "80%",
      padding: "10px",
    },
    lead: {
      textAlign: "left",
      font: "normal normal 900 20px/24px lato, sanserif",
      padding: theme.spacing(3),
      color: "#383838",
      [theme.breakpoints.down("sm")]: {
        font: "normal normal 900 20px/24px lato, sanserif",
        textAlign: "center",
        padding: theme.spacing(2),
      },
      [theme.breakpoints.up("sm")]: {
        font: "normal normal 640 16px/20px lato, sanserif",
        textAlign: "left",
        padding: theme.spacing(2),
       // margin: "0 5%",
      },
      [theme.breakpoints.up("md")]: {
        font: "normal normal 900 32px/40px lato, sanserif",
        textAlign: "left",
      },
    },
    leadContainer: {
      //backgroundColor: "#1A3343",
      padding: theme.spacing(3),
      color: "#ffffff !important",
      height: "690px",
      [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(2),
        height: "100%",
      },
      [theme.breakpoints.up("sm")]: {
        padding: theme.spacing(2),
        height: "100%",
      },
      [theme.breakpoints.up("md")]: {
        padding: theme.spacing(3),
        height: "480px",
       // padding: "15px",
      },
    },
    leadSpacing: {
      display: "flex",
      alignItems: "baseline",
      flexDirection: "column",
      //backgroundColor: "#3343",
      color: "#000000 !important",
      maxWidth: "50%",
    },
    donationFormIFrame: {
      backgroundColor: "#ffffff",
      border: "0px none transparent",
      overflow: "hidden",
      display: "inline-block",
      visibility: "visible",
      margin: "0px",
      padding: "0px",
      height: "auto",
      width: "100%",
      [theme.breakpoints.down("sm")]: {
        height: "auto",
      },
      [theme.breakpoints.up("sm")]: {
        height: "auto",
      },
      [theme.breakpoints.up("md")]: {
        height: "auto",
      },
    },
    donationFormContainer: {
      position: "relative",
      padding: "0px 60px 0 50px",
      //zIndex: "100",
      marginTop: "-365px",
      height: "auto",
      //backgroundColor: "#efefef",
      [theme.breakpoints.down("sm")]: {
        padding: 0,
        marginTop: 0,
      },
      [theme.breakpoints.up("sm")]: {
        padding: 0,
        marginTop: 0,
      },
      [theme.breakpoints.up("md")]: {
        padding: "0px 45px 0 80px",
        marginTop: "-415px",
      },
    },
    donationFormPaper: {
      backgroundColor: "#ffffff",
      boxShadow: "10px 10px 10px 5px rgba(0, 0, 0, .1)",
      [theme.breakpoints.down("sm")]: {
        boxShadow: "none",
      },
      [theme.breakpoints.up("sm")]: {
        boxShadow: "none",
      },
      [theme.breakpoints.up("md")]: {
        boxShadow: "10px 10px 10px 5px rgba(0, 0, 0, .1)",
      },
    },
    subTitle: {
      textAlign: "left",
      font: "normal normal 700 26px/32px lato, sanserif",
      width: "100%",
  
      // paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      // paddingLeft: theme.spacing(1),
      [theme.breakpoints.down("sm")]: {
        font: "normal normal 640 24px/35px lato, sanserif",
        textAlign: "left",
      },
      [theme.breakpoints.up("sm")]: {
        font: "normal normal 640 24px/28px lato, sanserif",
        textAlign: "left",
      },
      [theme.breakpoints.up("md")]: {
        font: "normal normal 600 26px/32px lato, sanserif",
        textAlign: "left",
      },
    },
      paragraph2: {
      font: "normal normal 400 26px/30px lato, sanserif",
      textAlign: "left",
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      maxWidth: "42%",
      [theme.breakpoints.down("sm")]: {
        font: "normal normal 500 16px/18px lato, sanserif",
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        textAlign: "left",
      },
      [theme.breakpoints.up("sm")]: {
        font: "normal normal 400 20px/24px lato, sanserif",
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(2),
        textAlign: "left",
      },
      [theme.breakpoints.up("md")]: {
        font: "normal normal 400 25px/30px lato, sanserif",
        textAlign: "left",
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
      },
    },
    paragraph3: {
      font: "normal normal 400 26px/30px lato, sanserif",
      textAlign: "left",
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      [theme.breakpoints.down("sm")]: {
        font: "normal normal 500 16px/18px lato, sanserif",
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        textAlign: "left",
      },
      [theme.breakpoints.up("sm")]: {
        font: "normal normal 400 20px/24px lato, sanserif",
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(2),
        textAlign: "left",
      },
      [theme.breakpoints.up("md")]: {
        font: "normal normal 400 25px/30px lato, sanserif",
        textAlign: "left",
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
      },
    },
    left: {
      textAlign: "left",
      margin: "30px 10px",
      color: "#535353",
      [theme.breakpoints.down("sm")]: {
        margin: "20px",
      },
      [theme.breakpoints.up("sm")]: {
        margin: "30px 10px",
      },
      [theme.breakpoints.up("md")]: {
        margin: "30px 10px",
      },
    },
    center: {
      textAlign: "center",
      margin: "20px 10px",
      color: "#535353",
      [theme.breakpoints.down("sm")]: {
        margin: "20px",
      },
      [theme.breakpoints.up("sm")]: {
        margin: "20px 10px",
      },
      [theme.breakpoints.up("md")]: {
        margin: "20px 10px",
      },
    },
    right: {
      textAlign: "right",
      margin: "30px 10px",
      color: "#535353",
      [theme.breakpoints.down("sm")]: {
        textAlign: "left",
        margin: "20px",
      },
      [theme.breakpoints.up("sm")]: {
        margin: "30px 10px",
      },
      [theme.breakpoints.up("md")]: {
        margin: "30px 10px",
      },
    },
    gridCenter: {
      display: "flex",
      flexDirection: "row",
      justify: "flex-start",
      alignItems: "center",
    },
    footer: {
      font: "normal normal 400 18px/25px futura-pt, sans-serif",
      marginTop: "40px",
    },
    
    leadHeavy: {
      textAlign: "left",
      font: "normal normal 900 50px/60px lato, sanserif",
      [theme.breakpoints.down("sm")]: {
        font: "normal normal 900 32px/35px lato, sanserif",
        textAlign: "left",
        paddingLeft: theme.spacing(3),
      },
      [theme.breakpoints.up("sm")]: {
        textAlign: "left",
        font: "normal normal 900 38px/45px lato, sanserif",
      },
      [theme.breakpoints.up("md")]: {
        textAlign: "left",
        font: "normal normal 900 50px/60px lato, sanserif",
      },
    },
    whiteText: {
      color: "#ffffff",
    },
    greyText: {
      color: "#7E7E7E",
    },
    
    
    paragraphSmall: {
      padding: theme.spacing(3),
      font: "normal normal 400 14px/18px lato, sanserif",
      textAlign: "left",
      [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(2),
        font: "normal normal 400 14px/18px lato, sanserif",
        textAlign: "center",
      },
      [theme.breakpoints.up("sm")]: {
        padding: theme.spacing(2),
        font: "normal normal 400 22px/26px lato, sanserif",
        textAlign: "left",
        margin: "0 5%",
      },
      [theme.breakpoints.up("md")]: {
        padding: theme.spacing(3),
        font: "normal normal 400 23px/30px lato, sanserif",
        textAlign: "left",
      },
    },
    paragraphMedium: {
      textAlign: "left",
      font: "normal normal 500 26px/36px lato, sanserif",
    },
    paragraphBold: {
      padding: theme.spacing(3),
      textAlign: "left",
      font: "normal normal 900 27px/33px lato, sanserif",
      [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(2),
        font: "normal normal 500 24px/28px lato, sanserif",
        textAlign: "center",
      },
      [theme.breakpoints.up("sm")]: {
        padding: theme.spacing(2),
        font: "normal normal 900 27px/33px lato, sanserif",
        textAlign: "left",
        margin: "0 5%",
      },
      [theme.breakpoints.up("md")]: {
        padding: theme.spacing(3),
        font: "normal normal 900 27px/33px lato, sanserif",
        textAlign: "left",
      },
    },
    quote: {
      font: "normal normal 640 30px/55px futura-pt, sanserif",
      fontStyle: "oblique",
      color: "#000000",
      maxWidth: "680px",
      textAlign: "center",
      margin: "0 auto",
      marginTop: theme.spacing(5),
    },
    author: {
      font: "normal normal 640 20px/22px futura-pt, sanserif",
      fontStyle: "oblique",
      marginTop: theme.spacing(2),
    },
    secure: {
      color: "#103fa1",
      font: "normal normal 900 25px/25px futura-pt, sans-serif",
      margin: "25px 0",
      backgroundColor: "#efefef",
    },
    heavy: {
      font: "normal normal 700 32px/48px futura-pt, sans-serif",
      marginTop: "10px",
      [theme.breakpoints.down("sm")]: {
        font: "normal normal 700 28px/36px futura-pt, sans-serif",
      },
      [theme.breakpoints.up("sm")]: {
        font: "normal normal 700 32px/48px futura-pt, sans-serif",
      },
      [theme.breakpoints.up("md")]: {
        font: "normal normal 700 32px/48px futura-pt, sans-serif",
      },
    },
    imgJoinTheCharge: {
      marginTop: "-0px",
    },
    demi: {
      font: "normal normal 500 20px/35px futura-pt, sans-serif",
      [theme.breakpoints.down("sm")]: {
        font: "normal normal 500 20px/35px futura-pt, sans-serif",
        marginBottom: "20px",
      },
      [theme.breakpoints.up("sm")]: {
        font: "normal normal 500 20px/35px futura-pt, sans-serif",
      },
      [theme.breakpoints.up("md")]: {
        font: "normal normal 500 20px/35px futura-pt, sans-serif",
      },
    },
    paragraph: {
      font: "normal normal 500 24px/35px futura-pt, sans-serif",
      textAlign: "justify !important",
      wordBreak: "keep-all",
      [theme.breakpoints.down("sm")]: {
        font: "normal normal 400 18px/26px futura-pt, sans-serif",
      },
      [theme.breakpoints.up("sm")]: {
        font: "normal normal 500 24px/35px futura-pt, sans-serif",
      },
      [theme.breakpoints.up("md")]: {
        font: "normal normal 500 24px/35px futura-pt, sans-serif",
      },
    },
    spaceText: {
      marginLeft: "5px",
      position: "relative",
      top: "2px",
    },
    donationForm: {
      padding: "5px",
      overflow: "visible",
      backgroundColor: "#efefef",
    },
    imgFluid: {
      maxWidth: "100%",
      height: "auto",
    },
    headerUnderline: {
      font: "normal normal 640 30px/36px futura-pt, sans-serif",
      textDecoration: "underline",
      color: "#000000",
    },
    divider: {
      marginTop: "80px",
      marginBottom: "80px",
      color: "#535353 !important",
      [theme.breakpoints.down("sm")]: {
        marginTop: 0,
      },
      [theme.breakpoints.up("sm")]: {
        marginTop: 0,
      },
      [theme.breakpoints.up("md")]: {
        marginTop: "80px",
      },
    },
    marginTop4: {
      marginTop: "1rem",
      [theme.breakpoints.down("sm")]: {
        marginTop: 0,
      },
      [theme.breakpoints.up("sm")]: {
        marginTop: "1rem",
      },
      [theme.breakpoints.up("md")]: {
        marginTop: "1rem",
      },
    },
    marginTop6: {
      marginTop: "6rem",
      [theme.breakpoints.down("sm")]: {
        marginTop: "3rem",
      },
      [theme.breakpoints.up("sm")]: {
        marginTop: "6rem",
      },
      [theme.breakpoints.up("md")]: {
        marginTop: "6rem",
      },
    },
    imgSmall: {
      width: "50%",
      [theme.breakpoints.down("sm")]: {
        width: "90%",
      },
      [theme.breakpoints.up("sm")]: {
        width: "80%",
      },
      [theme.breakpoints.up("md")]: {
        width: "50%",
      },
    },
    fontH1: {
      fontSize: "2.5rem",
      [theme.breakpoints.down("sm")]: {
        fontSize: "2rem",
      },
      [theme.breakpoints.up("sm")]: {
        fontSize: "2.5rem",
      },
      [theme.breakpoints.up("md")]: {
        fontSize: "2.5rem",
      },
    },
    progressBar: {
      padding: theme.spacing(3),
      color: "#000000 !important",
      border: "1px solid #cccccc",
      boxShadow: "5px 5px 5px 0px rgba(0, 0, 0, .1)",
      [theme.breakpoints.down("sm")]: {
        boxShadow: "none",
        padding: theme.spacing(1),
        paddingLeft: theme.spacing(3),
      },
      [theme.breakpoints.up("sm")]: {
        boxShadow: "none",
        padding: theme.spacing(2),
      },
      [theme.breakpoints.up("md")]: {
        boxShadow: "5px 5px 5px 0px rgba(0, 0, 0, .1)",
        padding: theme.spacing(3),
      },
    },
    mobileViewMargin: {
      [theme.breakpoints.down("sm")]: {
        marginTop: "60px",
      },      
    },  
    mobileView: {
      [theme.breakpoints.down("sm")]: {
        display: "block",
      },
      [theme.breakpoints.up("sm")]: {
        display: "none",
      },
      [theme.breakpoints.up("md")]: {
        display: "none",
      },
    },
    desktopView: {
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
      [theme.breakpoints.up("sm")]: {
        display: "block",
      },
      [theme.breakpoints.up("md")]: {
        display: "block",
      },
    },
  }));

const Home = ({ ...props }) => {
    const classes = useStyles();
 

      const bannerData = {
        id: 0,
        image: donateBannerDesktop,
        imageClass: "mainFeaturedPostDonate",
        backgroundColor: "#ffffff",
        /*textContainer: "textContainerMiddle",
        text: firstLine,
        text2: secondLine,
        textClass: "text1Class",
        text2Class: "text2Class",
        columnLeft: 6,
        columnRight: 6,
        align: "left",
        menu: false,*/
      };

      const bannerDataMobile = {
        id: 0,
        image: donateBannerMobile,
        backgroundColor: "#ffffff",
        imageClass: "mainFeaturedPost",
        /*text: firstLine,
        text2: secondLine,
        textClassM: "whiteTextMargin",
        columnLeft: 12,
        columnRight: 12,
        align: "left",
        menu: true,
        topM: "6%",*/
      };

    return (
        <div
        style={{
          maxWidth: "1440px",
          margin: "0 auto",
          backgroundColor: "#ffffff",
          borderRight: "0.5px solid #fff4eb",
          borderLeft: "0.5px solid #fff4eb",
          marginTop: "-133px"
        }}
      >
    <div className={classes.root}>
    {isMobile && <StarHero data={bannerDataMobile} />}
    {isBrowser && <StarHero data={bannerData} />}
    {/*isBrowser && <StarHero data={bannerData} />}
        {/*(isMobile || (isBrowser && width < 1220)) && (
          <Box height="100%">
            <Grid
              container
              spacing={0}
              className={classes.donationFormContainer}
            >
              <DonationForm
                showDiv={false}
                classes={classes}
                partnerId={partnerId}
                summary={summary}
                progress={progress}
                goal={goal}
                goalOn={goalOn}
                offset={offset}
              />
            </Grid>
          </Box>
        )*/}
        
          <Grid container spacing={0} className={classes.leadContainer}>
            <Grid item xs={12} sm={6} className={`${classes.leadSpacing} ${classes.desktopView}`}>
              <Box className={`${classes.lead}`}>
              PROVIDE ACCESS TO CLEAN WATER
              <Typography variant="h5" className={classes.subTitle}>
              Help us build more Solar Water Farms in communities around the world</Typography>
              <Box className={classes.paragraph}>
              Over 1 billion people currently live in water-scarce regions of the world. With
              GivePower’s revolutionary Solar Water Farm technology, $1 can provide access to an entire
              year of clean drinking water to someone in need. That means for just $20 you can
              help give clean water access to someone in need for up to 20 years.</Box>
              <Box className={classes.paragraphBold}>
              How many lives do you want to change?
              </Box>              
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} className={`${classes.leadSpacingMobile} ${classes.mobileView}`}>
              <Box className={`${classes.lead}`}>
              PROVIDE ACCESS TO CLEAN WATER
              <Typography variant="h5" className={classes.subTitle}>
              Help us build more Solar Water Farms in communities around the world</Typography>
              <Box className={classes.paragraph}>
              Over 1 billion people currently live in water-scarce regions of the world. With
              GivePower’s revolutionary Solar Water Farm technology, $1 can provide access to an entire
              year of clean drinking water to someone in need. That means for just $20 you can
              help give clean water access to someone in need for up to 20 years.</Box><br />
              <Box className={classes.paragraphBold}>
              How many lives do you want to change?
              </Box>
              </Box>
              </Grid>
              <Grid item xs={12} sm={12} md={6} id="donate" name="donate">
      <div className={classes.donationFormContainer}>
          <Paper elevation={0} className={`${classes.paper} ${classes.donationFormPaper}`}>
            <Box className={classes.donationForm}>
              <Box className={classes.secure}>
                <FontAwesomeIcon icon={faLock} color="#3355c1" size="xs" />
                <span className={classes.spaceText}>Secure Donation</span>
              </Box>
              <iframe
                className="donately-donation-iframe"
                frameBorder="0"
                allowtransparency="true"
                title="Be the Power for Change"
                style={{
                  backgroundColor: "#efefef",
                  border: "0px none transparent",
                  overflow: "hidden",
                  display: "inlineBlock",
                  visibility: "visible",
                  margin: "0px",
                  padding: "0px",
                  height: "940px",
                  width: "100%",
                }}
                /*src="https://cdn.donately.com/dntly-core/current/iframe.html?form_id=frm_04a561ee3a68&amp;donately_id=act_d6b0b0246254&amp;stripe_publishable_key=pk_live_IRMEinbjKnY5R76XR8sQ2qtZ&amp;donately_ga_account=UA-123029666-1&amp;donately_anonymous=true&amp;donately_campaign_id=cmp_5774d85abad0&amp;donately_currency=true&amp;data-donately-custom-css=%7B%22.donately-donation-form%20.donately-btn%22:%7B%22width%22:%22100%25%22%7D%2C%20%22.donately-donation-form%20.donately-btn%22:%7B%22background-color%22:%22%232e4cac%22%7D%2C%20%22.donately-donation-form%20.donately-btn%3Ahover%22:%7B%22background-color%22:%22%233355c1%22%7D%7D&amp;donately_donor_pays_fees=%7B%22cc%22:%7B%22processor_percent%22:%220.029%22,%22processor_fixed%22:%220.30%22,%22dntly_percent%22:%220.03%22%7D%7D"*/
                src="https://cdn.donately.com/core/5.2/donate-form.html?form_id=frm_04a561ee3a68&amp;account_id=act_d6b0b0246254&amp;stripe_key=pk_live_IRMEinbjKnY5R76XR8sQ2qtZ"
              />
              <Box className={classes.questions}>
                For questions about or changes to an existing donation, please
                send an email to{" "}
                <a className={classes.link} href="mailto:finance@givepower.org">
                  finance@givepower.org
                </a>
              </Box>
            </Box>
          </Paper>
          </div>
        </Grid>
          </Grid>
          <Grid container spacing={3} className={classes.mobileViewMargin}>
        <Grid item xs={12} sm={6}>
          <Paper elevation={0} className={classes.paper}>
            <Box className={classes.imgJoinTheCharge} >
              <img
                /* src="https://res.cloudinary.com/loanpal/image/upload/v1650926205/givepower/donate/donate-sustain-tall.jpg"*/
                src="https://res.cloudinary.com/loanpal/image/upload/w_auto,q_auto,dpr_auto,c_scale/v1637952499/givepower/donate/donate-provide.jpg"
                className={classes.img}
                //style={{ width: "120%" }}
                alt="Be the power for change"
                style={{marginTop: "-40px"}}
              />
            </Box>
          </Paper>
        </Grid>
         {/* <Grid item xs={12} sm={6} className={classes.gridCenter}>
          <Paper elevation={0} className={classes.paper}>
            <Box className={classes.left}>
             {/*<Typography variant="h4" className={classes.heavy}>
                <br />
                <br />
                <br />
                BECOME A SUSTAINING SUPPORTER
              </Typography>
              <Typography variant="h5" className={classes.subTitle}>
                Make an impact every month
              </Typography>
              <Box className={classes.paragraph}>
                Your monthly gift to GivePower supports our life-changing
                programs. By providing people with access to clean water, powering
                schools, improving conservation efforts, delivering emergency relief to
                a disaster-stricken community and more, your on-going support
                enables us to do what is necessary, when it's necessary.
            </Box>
              
            </Box>
          </Paper>
        </Grid> */}
      </Grid>
     <Grid container spacing={3}>
     <Grid item xs={12} sm={6} className={classes.mobileView}>
          <Paper elevation={0} className={classes.paper}>
            <Box className={classes.imgJoinTheCharge}>
              <img
                /*src="https://res.cloudinary.com/loanpal/image/upload/w_auto,q_auto,dpr_auto,c_scale/v1637952499/givepower/donate/donate-provide.jpg"*/
                src="https://res.cloudinary.com/loanpal/image/upload/w_auto,q_auto,dpr_auto,c_scale/v1637952499/givepower/donate/donate-sustain.jpg"
                className={classes.img}
                alt="Be the power for change"                
              />
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} className={classes.gridCenter}>
          <Paper elevation={0} className={classes.paper}>
            <Box className={classes.lead}>
              <Typography variant="h4" className={classes.heavy}>
              BECOME A SUSTAINING SUPPORTER
              </Typography>
              <Typography variant="h5" className={classes.subTitle}>
              Make an impact every month
                </Typography>
              <Box className={classes.paragraph}>
                Your monthly gift to GivePower supports our life-changing
                programs. By providing people with access to clean water, powering
                schools, improving conservation efforts, delivering emergency relief to 
                a disaster-stricken community and more, your on-going support
                enables us to do what is necessary, when it's necessary.
              </Box>
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} className={classes.desktopView}>
          <Paper elevation={0} className={classes.paper}>
            <Box className={classes.imgJoinTheCharge}>
              <img
                /* src="https://res.cloudinary.com/loanpal/image/upload/w_auto,q_auto,dpr_auto,c_scale/v1637952499/givepower/donate/donate-provide.jpg" */
                src="https://res.cloudinary.com/loanpal/image/upload/w_auto,q_auto,dpr_auto,c_scale/v1637952499/givepower/donate/donate-sustain.jpg"
                className={classes.img}
                alt="Be the power for change"
                style={{marginTop: "-60px"}}
              />
            </Box>
          </Paper>
        </Grid>
      </Grid>
       <Grid container spacing={3}>
        <Grid item xs={12} sm={12} className={classes.footer}>
          <Paper elevation={0} className={classes.paper}>
            <Box className={classes.center}>
              <p>Are you a company that values giving back?{" "}
              <a href="https://givepower.org/get-involved/">Partner with us</a>!<br />
              Interested in funding an entire project? Please contact us at{" "}
              <a href="mailto:donate@givepower.org">donate@givepower.org</a>, to
              discuss your goals<br />
              GivePower is a 501(c)(3) charitable organization, and all
              donations made are tax-deductible for donors located in the United
              States. Our federal EIN is 47-1265705
              </p>    
            </Box>        
          </Paper>
        </Grid>
      </Grid>
     </div>   
    </div>
    );
  };    


export default Home;